// src/redux/services/SezInfoSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapSezinfoResponse,
  mapSezinfoRequest,
} from "@/redux/mappers/Export/CreateNewJob/SezInfoMappers";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  

export const sezinfoApi = createApi({
  reducerPath: "sezinfoApi",
  baseQuery,
  tagTypes: ["SezInfo"],
  endpoints: (builder) => ({
    // ✅ Fetch by ExportMasterId
    getSezInfoById: builder.query({
      query: ({id}) => `export/sez/${id}`,
      transformResponse: (response) =>
        response?.data ? mapSezinfoResponse(response.data) : null,
      providesTags: (result, error, id) => [{ type: "SezInfo", id }],
    }),

    // ✅ Update SEZ info (PUT)
    updateSezInfo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `export/sez/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
        body: {sez: data},
      }),
      invalidatesTags: ["SEZ"],
    }),
  }),
});

export const {
  useLazyGetSezInfoByIdQuery,
  useUpdateSezInfoMutation,
} = sezinfoApi;


